import Layout from '@/layout'
import empty from '@/layout/empty'
import { PERMISSION_EQUAL_BTN_PATH, WHITE_PERMISSION } from '@/store/constants'

export function getAsyncRoutes(routes = []) {
  const res = []
  // 定义路由中需要的自定名
  const keys = [
    'path',
    'name',
    'children',
    'redirect',
    'meta',
    'hidden',
    'button'
  ]
  // 遍历路由数组去重组可用的路由
  routes.forEach((item) => {
    const newItem = {}
    if (item.component) {
      // 判断 item.component 是否等于 'Layout',若是则直接替换成引入的 Layout 组件
      if (item.component === 'Layout') {
        newItem.component = Layout
      } else if (item.component === 'empty') {
        newItem.component = empty
      } else {
        // newItem.component = () => import(`../../views/${item.component}.vue`)
        newItem.component = (resolve) =>
          require([`@/views/${item.component}`], (...arg) => {
            const comp = arg[0]?.default
            comp.name = item.name
            return resolve(...arg)
          })
        // 此处用reqiure比较好，import引入变量会有各种莫名的错误
        // newItem.component = () => import(`@/views/${item.component}`)
      }
    }

    if (item.meta && typeof item.meta === 'string') {
      item.meta = JSON.parse(item.meta)
      // 业务线数据保存
      if (item.moduleCode) {
        item.meta.moduleCode = item.moduleCode
      }
    }

    for (const key in item) {
      if (keys.includes(key)) {
        newItem[key] = item[key] ? item[key] : undefined
      }
    }

    /** button 配置列表注入meta中 */
    newItem.meta.buttons = newItem.button

    // 若遍历的当前路由存在子路由，需要对子路由进行递归遍历
    if (newItem.children && newItem.children.length) {
      // eslint-disable-next-line no-unused-vars
      newItem.children = getAsyncRoutes(item.children)
    }
    // 对于iframe页面路由处理
    if (newItem.meta.pageId) {
      newItem.meta.component = newItem.component
    }
    res.push(newItem)
  })
  // 返回处理好且可用的路由数组
  return res
}

// 获取所有的权限码
function collectPermissionCodes(obj) {
  const permissionCodes = []
  function traverse(obj) {
    if (obj && typeof obj === 'object') {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty('permissionCode')) {
        permissionCodes.push(obj.permissionCode)
      }
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty('children') && Array.isArray(obj.children)) {
        obj.children.forEach((child) => traverse(child))
      }
    }
  }

  traverse(obj)

  return permissionCodes
}

export function getAllButtons(data) {
  let buttons = []
  function traverse(node) {
    if (node.button && node.button.length > 0) {
      buttons = buttons.concat(node.button)
    }
    if (node.children && node.children.length > 0) {
      node.children.forEach((child) => {
        traverse(child)
      })
    }
  }
  traverse(data)
  return buttons
}

function filterPermissionCode(routes = {}, codes = []) {
  if (routes.children?.length > 0) {
    routes.children.forEach((item) => {
      if (item.children?.length > 0) {
        item.children = item.children.filter((item) => {
          return (
            codes.indexOf(PERMISSION_EQUAL_BTN_PATH[item.permissionCode]) >
              -1 ||
            !item.hidden ||
            WHITE_PERMISSION.indexOf(item.permissionCode) > -1
          )
        })
      }
    })
  }
  return routes
}

// 过滤路由中的权限码
export function checkPermissionCode(permissions = {}, btnCodes = []) {
  // const btnCodes = getAllButtons(permissions)?.map((_) => _.permissionCode)
  const res = filterPermissionCode(permissions, btnCodes)
  return res.children
}
